import React from "react";
import { Container } from "./styles";
import project from "../../assets/project.png";
import { Reveal } from "../Reveal/Reveal";
import { useI18n } from "../../i18n/I18nProvider";
import { Card } from "../Card/Card";
import { Carousel } from "../Carousel/LazyCarousel";
import { TileCard } from "../Card/TileCard";
import trackEvent from "../../utils/analytics";
import githubIcon from '../../assets/github-icon.svg'

interface IProject {
  title: string;
  description: string;
  mainSkills: string[];
  allSkills: string[];
  links: Array<{
    label: string;
    url: string;
    icon: string;
  }>;
  longtext: Array<{
    type: string;
    value: string;
  }>;
  isMain?: boolean;
}

interface IPortfolioProps {
  isMain?: boolean;
}
// Carousel shows all projects; previous visible count no longer used.

export function Portfolio({ isMain = false }: IPortfolioProps) {
  const { t } = useI18n();
  const [showCard, setShowCard] = React.useState<IProject>();

  const visibleProjects = isMain ? t.projects.projects.filter((p) => p.isMain) : t.projects.projects.filter((p) => !p.isMain);

  return (
    <Container id="portfolio" className={isMain ? "main" : ""}>
      <h2>{isMain ? t.projects.mainTitle : t.projects.title}</h2>
      <div className="subtitle">{t.projects.subtitle}</div>
      <Projects projects={visibleProjects} setShowCard={setShowCard} results={t.projectResults} />
      {!isMain &&
        <div className="footer-portfolio">
          <div className="footer-text">{t.projects.footerText}</div>

          <a
            href="https://github.com/FAngelo94"
            target="_blank"
            rel="noreferrer"
            onClick={() => void trackEvent("contact_click", { label: "github", href: "https://github.com/FAngelo94" })}
          >
            <img src={githubIcon} alt="GitHub" loading="lazy" />
          </a>
        </div>}
      {showCard && (
        <Card
          title={showCard.title}
          text={showCard.longtext}
          skills={showCard.allSkills}
          handleClose={() => setShowCard(undefined)}
        />
      )}

    </Container>
  );
}

const Projects = ({ projects, setShowCard, results }: { projects: IProject[], setShowCard: (project: IProject) => void, results?: Record<string, string> }) => {
  return (
    <Carousel>
      {projects.map((p, index) => {
        const result = results?.[p.title];
        return (
        <Reveal animateIn="flipInX" key={index}>
          <TileCard
            analyticsLabel={p.title}
            headerIconSrc={project}
            headerRight={p.links ? (
              <>
                {p.links.map((l, index2) => (
                  <a href={l.url} key={index2} target="_blank" rel="noreferrer">
                    <img src={l.icon} alt={l.label} loading="lazy" />
                  </a>
                ))}
              </>
            ) : undefined}
            title={p.title}
            body={
              <>
                {result && (
                  <p style={{ color: "var(--green)", fontWeight: 600, margin: "0 0 0.6rem" }}>
                    {result}
                  </p>
                )}
                <p>{p.description}</p>
              </>
            }
            footerList={p.mainSkills}
            onClickBody={() => setShowCard(p)}
          />
        </Reveal>
        );
      })}
    </Carousel>
  )
}
